import * as types from '../types/pickUpTime';
import moment from 'moment/moment';
import * as _ from 'lodash';
import {getOrderPeriod} from '../helpers';

export function changeTime(data) {
  return dispatch => {
    return dispatch({
      type: types.SET_OPTION,
      data: data,
    });
  };
}

function setAvailableTimes(times) {
  return {
    type: types.CALC_TIMES,
    data: times,
  };
}

export function calcAvailableTimes(restaurant, time) {
  let currentTime = time ? moment(time, 'HH:mm:ss') : moment();
  let times = [];

  if (_.isEmpty(restaurant)) {
    return setAvailableTimes(times);
  }

  const {timetable, default_order_cooking_time, pick_up_open_time} = restaurant;

  const currentDay = moment().format('ddd').toLowerCase();

  let startFromTimetable = moment(timetable[`${currentDay}_start_time`], 'HH:mm:ss');
  const endFromTimetable = moment(timetable[`${currentDay}_end_time`], 'HH:mm:ss');

  const orderPeriod = getOrderPeriod(restaurant);

  if (!_.isNull(pick_up_open_time)) {
    const pickUpOpenTime = moment(pick_up_open_time, 'HH:mm:ss');
    if (endFromTimetable < pickUpOpenTime) {
      return setAvailableTimes(null);
    }
    if (startFromTimetable < pickUpOpenTime) {
      startFromTimetable = pickUpOpenTime;
    }
  }

  currentTime = currentTime.add(parseInt(orderPeriod, 10), 'minutes');

  if (endFromTimetable.isBefore(startFromTimetable)) {
    endFromTimetable.add(1, 'day');
  }

  let timeClone = startFromTimetable.clone();

  while (timeClone.isSameOrBefore(endFromTimetable)) {
    times.push({
      value: timeClone.clone().format('HHmm'),
      label: timeClone.clone().format('HH:mm'),
    });
    timeClone.add(default_order_cooking_time, 'minutes');
  }
  times = times.filter(obj => {
    return moment(obj.label, 'HH:mm').isAfter(currentTime);
  });

  return setAvailableTimes(times);
}

export function setServerTime(times) {
  return {
    type: types.SET_SERVER_TIME,
    data: times,
  };
}


// WEBPACK FOOTER //
// ./src/actions/pickUpTimeActions.js